import { render, staticRenderFns } from "./ServeTeamType.vue?vue&type=template&id=3fefc297&"
import script from "./ServeTeamType.vue?vue&type=script&lang=js&"
export * from "./ServeTeamType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports